import { gql } from './apollo';

export const GET_PROMO_ITEMS_FOR_PROPERTY = gql`
    query ($property__c_id: MultiTypeInput!, $offset: Int = 0, $limit: Int = 10) {
        table(
            name: "gc_inventory_promo_items"
            filter: [{ left: "property__c_id", right: $property__c_id, expression: "=" }]
            contain: [
                {
                    table: "propertyuser__c"
                    alias: "created_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "created_by"
                    limit: 1
                }
            ]
            orderBy: "date"
            orderByDirection: DESC
            offset: $offset
            limit: $limit
        )
    }
`;

export const GET_PROMO_ITEM_BY_ID = gql`
    query ($id: MultiTypeInput!) {
        table(
            name: "gc_inventory_promo_items"
            filter: [{ left: "id", right: $id, expression: "=" }]
            contain: [
                {
                    table: "propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "created_by"
                    limit: 1
                }
            ]
            limit: 1
        )
    }
`;

export const CREATE_PROMO_ITEM = gql`
    mutation (
        $property__c_id: MultiTypeInput
        $reason: MultiTypeInput
        $description: MultiTypeInput
        $brand: MultiTypeInput
        $quantity: MultiTypeInput
        $event_date: MultiTypeInput
        $distribution_method: MultiTypeInput
        $remaining_inventory: MultiTypeInput
        $remaining_use: MultiTypeInput
        $notes: MultiTypeInput
        $created_by: MultiTypeInput
        $date: MultiTypeInput
    ) {
        createRow(
            table: "gc_inventory_promo_items"
            values: [
                { property: "property__c_id", value: $property__c_id }
                { property: "reason", value: $reason }
                { property: "description", value: $description }
                { property: "brand", value: $brand }
                { property: "quantity", value: $quantity }
                { property: "event_date", value: $event_date }
                { property: "distribution_method", value: $distribution_method }
                { property: "remaining_inventory", value: $remaining_inventory }
                { property: "remaining_use", value: $remaining_use }
                { property: "notes", value: $notes }
                { property: "created_by", value: $created_by }
                { property: "date", value: $date }
            ]
        )
    }
`;

export const DELETE_PROMO_ITEM = gql`
    mutation ($id: String!) {
        deleteRow(table: "gc_inventory_promo_items", id: $id)
    }
`;

export const GET_DISTINCT_PROMO_REASONS_FOR_PROPERTY = gql`
    query ($property__c_id: MultiTypeInput!) {
        table(
            name: "gc_inventory_promo_items"
            columns: ["reason"]
            filter: [
                { left: "property__c_id", right: $property__c_id, expression: "=" }
                { left: "reason", expression: "IS NOT NULL" }
            ]
            limit: 1000
        )
    }
`;
